import React from 'react'
import { LucideIcon } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip.tsx'

type ToolProps = {
    icon: LucideIcon
    action?: React.MouseEventHandler<HTMLButtonElement>
    title?: string
    active?: boolean
}

export const Tool = React.forwardRef<HTMLButtonElement, ToolProps>(({ icon: Icon, action, title, active }, ref) => {
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <button
                    ref={ref}
                    type="button"
                    className={`cursor-pointer aspect-square rounded-md px-1 hover:ring ring-mm-border ${
                        active ? 'ring bg-mm-bg' : 'bg-none'
                    }`}
                    onClick={action}
                    aria-label={title}
                >
                    <Icon aria-hidden="true" size={16} />
                </button>
            </TooltipTrigger>
            <TooltipContent>{title}</TooltipContent>
        </Tooltip>
    )
})
